var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"nav nav-tabs p-0",attrs:{"id":"myTab","role":"tablist"}},[_c('li',{staticClass:"nav-item"},[_c('button',{staticClass:"nav-link active",attrs:{"id":"a-tab","data-bs-toggle":"pill","data-bs-target":"#a","type":"button","role":"tab","aria-controls":"a"}},[_vm._v(" 支援入力 ")])])])])
}]

export { render, staticRenderFns }